
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/news/stories/item/[slug]",
      function () {
        return require("private-next-pages/[locale]/news/stories/item/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/news/stories/item/[slug]"])
      });
    }
  